module.exports = __webpack_public_path__ + "img/cacauIndex.fb4804d7.jpg";